export const Colors = [
  {
    backgroundColor: '#D1EBDE',
    color: '#1C5C3B'
  },
  {
    backgroundColor: '#E2DEED',
    color: '#443C60'
  },
  {
    backgroundColor: '#CDDAEA',
    color: '#123054'
  },
  {
    backgroundColor: '#E8DDD9',
    color: '#55382A'
  },
  {
    backgroundColor: '#DBF0F2',
    color: '#33676A'
  },
  {
    backgroundColor: '#FDEFCA',
    color: '#7E5E11'
  },
  {
    backgroundColor: '#C7D4E7',
    color: '#032051'
  }
];
